import React from "react";
import { Route, Switch } from "react-router-dom";

import PageNotFound from "./404/PageNotFound";

import LoginInTheHouse from "./LoginInTheHouse";
import Resetpassword from "./ResetPassword";


// import ReactPlaye from "./ReactPlayer";

function index(props) {
  return (
    <Switch>
      <Route path="/" exact component={LoginInTheHouse} />
      <Route path="/Resetpassword" exact component={Resetpassword} />
      <Route path="*" exact component={PageNotFound} />
    </Switch>
  );
}

export default index;
